import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable';
// import ThreeStepsHeadingModal from '../Modal/ThreeStepsModal/ThreeStepsHeadingModal';
// import ThreeStepsCardDesignModal from '../Modal/ThreeStepsModal/ThreeStepsCardDesignModal';
import { Grid } from '@mui/material';
// import OffersCardDesignModal from '../Modal/OffersModal/CommonCardDesignModal';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
import ReferralsHeadingModal from '../Modal/ReferModal/ReferralsHeadingModal';
import InviteFriends from '../ReferralsContentPreview/InviteFriendsPreview/InviteFriend';
import { useDispatch, useSelector } from 'react-redux';
// import ReferSection from './ReferralsPreview/ReferSection';
// import ReferralsHeadingModal from '../../CommonModal/ReferModal/ReferralsHeadingModal';

const ReferralsSection = () => {


    const tableData = [
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

    ];
    // const tableHeadData = ['S.No', 'Title', 'Content', "Document", 'Status'];

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [editCardsData, setEditCardsData] = useState(
        [
            { card_title: 'Card 1', card_content: 'Content 1', image: null },
            { card_title: 'Card 2', card_content: 'Content 2', image: null },
            { card_title: 'Card 3', card_content: 'Content 3', image: null },
            { card_title: 'Card 4', card_content: 'Content 4', image: null }
        ]
    );

    //   ================================================

    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No','Title', 'Content','Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role",  "Status"]
        : ['S.No', 'Title', 'Content', 'Status']





    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getReferralSectionById } = useSelector(state => state?.getReferralSectionById);
    const { addReferralSection } = useSelector(state => state?.addReferralSection);

    const { updateReferralSection } = useSelector(
        (state) => state?.updateReferralSection);

    const { deleteReferralSection } = useSelector(
        (state) => state?.deleteReferralSection);




    const { getAllReferralSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllReferralSectionsWithCreatorBySectionName);

    const { getAllReferralSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllReferralSectionsBySectionNameBasedOnCreator);

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllReferralSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addReferralSectionWithApproval } = useSelector(
        (state) => state?.addReferralSectionWithApproval);




    const { updateReferralSectionForReApproval } = useSelector(
        (state) => state?.updateReferralSectionForReApproval);




    const { approveReferralSection } = useSelector((state) => state?.approveReferralSection);
    const { rejectReferralSection } = useSelector((state) => state?.rejectReferralSection);





    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "referrals" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllReferralSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "referrals" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllReferralSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)
                console.log(responseData?.payload, "responseDataruejwhrjek")


            }
        }


        fetchData();
    }, [addReferralSection, addReferralSectionWithApproval, deleteReferralSection, updateReferralSection, updateReferralSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllReferralSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({
             
                    title: data?.heading || '--',
                    // secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllReferralSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    // secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"

                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllReferralSectionsBySectionNameBasedOnCreator, getAllReferralSectionsWithCreatorBySectionName]);



    console.log(rowTableData, "rowTableDatattattata")



    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteReferralSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETEREFERRALSSECTION(data1));
        if (responseData?.payload?.message === "Referral Section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }

    // ==========================================================================

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable
                    tableDelete={permissions?.ContentManagement?.Referrals.delete}
                    // editData={editCardsData}
                    editModalName={ReferralsHeadingModal}

                    tableView={true}
                    modalVeiwName={PreviewComponent}

                    ModalPreviewComponent1={InviteFriends}
                    handleTableDataDelete={handleTableDataDelete}
                    sectionNameForApproveAndReject="RefreralsSection"


                    // section_name="offers"
                    tableEdit={permissions?.ContentManagement?.Referrals.edit}
                    dataCreate={permissions?.ContentManagement?.Referrals.add}
                    tableData={rowTableData} title="Referrals" tableHeadData={tableHeadData} modalName={ReferralsHeadingModal} />

            </Grid>
        </Grid>
    )
}

export default ReferralsSection